module.exports = __webpack_public_path__ + "img/yiquantong.d794dd67.png";